/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react'
import { AuthConsumer } from '@/contexts/auth'
import styles from './LoginComponent.scss'
import { MagazineLoader } from '@/components/commons/LoaderComponent'
import { FormFields } from '@/components/commons/FormFields'
import { emailRegex } from '@/constants'
import Link, { LinkedComponent } from 'valuelink'
import { getLanguageKeys } from '../../../store/getters/language'
import { connect } from 'react-redux'

import informationError from '@/assets/information.svg'

class LoginComponent extends LinkedComponent {
  constructor ( props ) {
    super( props )
    this.state = {
      username: '',
      password: '',
      sending: false,
    }

    this.onFormSubmit = this.onFormSubmit.bind( this )
  }

  onFormSubmit ( e ) {
    e.preventDefault()
  }

  render () {
    const sending = this.state.sending
    const { locales } = this.props

    const requiredMessage =
      locales['general-message-required'] || 'Field is required'

    const nameLink = Link.state( this, 'username' )
      .check( x => x, requiredMessage )
      .check( x => x.match( emailRegex ), locales['login-wrong-email-format'] )

    const passwordLink = Link.state( this, 'password' ).check(
      x => x,
      requiredMessage
    )

    return (
      <React.Fragment>
        <div className={styles.background} />
        <div className={styles.composition}>
          <div className="text">
            <span>{locales['general-logo-line1']}</span>
            <h1>{locales['general-logo-line2']}</h1>
            <span>{locales['general-logo-line3']}</span>
          </div>
          <div className={styles.effect} round="top" />
          <div className={styles.effect} round="right" />
          <div className={styles.effect} line="vertical" />
          <div className={styles.effect} line="horizontal" />
        </div>
        <form className={styles.form} onSubmit={this.onFormSubmit}>
          <div>
            <div className={styles['form-title']}>
              <h1>{locales['login-title']}</h1>
            </div>
            {sending ? (
              <MagazineLoader />
            ) : (
              <React.Fragment>
                <FormFields
                  className={`${
                    styles['input-login-style']
                  } m-bottom-xlarge`}
                  valueLink={nameLink}
                  placeholder={locales['login-email']}
                />

                <FormFields
                  type="password"
                  className={styles['input-login-style']}
                  valueLink={passwordLink}
                  placeholder={locales['login-password']}
                />
                <AuthConsumer>
                  {( { doLogin, error } ) => (
                    <React.Fragment>
                      <button
                        onClick={() => doLogin( this.state )}
                        disabled={nameLink.error || passwordLink.error}
                      >
                        <span>{locales['login-confirm']}</span>
                      </button>

                      {error && (
                        <div className={styles.error}>
                          <img src={informationError} alt="123" />
                          <div className={styles['write-error']}>
                            <h1>Important warning</h1>
                            <span>{error}</span>
                          </div>
                        </div>
                      )
                      }
                    </React.Fragment>
                  )}
                </AuthConsumer>
                 
              </React.Fragment>
            )}
          </div>
        </form>
      </React.Fragment>
    )
  }
}

const mapStateTiProps = state => {
  const locales = getLanguageKeys( state )
  return { locales }
}

export default connect( mapStateTiProps )( LoginComponent )



// WEBPACK FOOTER //
// ./src/components/auth/login/LoginComponent.js